export const APP_CONFIG = {
  // Meeting Configuration
  MAX_PARTICIPANTS_DEFAULT: 100,
  MAX_CONCURRENT_SCREEN_SHARES: 4,
  MAX_MEETING_TITLE_LENGTH: 100,
  MAX_PARTICIPANT_NAME_LENGTH: 50,

  // Heartbeat Configuration
  HEARTBEAT_INTERVAL_MS: 30000, // 30 seconds

  // UI Configuration
  TOAST_DURATION_MS: 5000,
  LOADING_DELAY_MS: 300,
} as const;

export const ROUTES = {
  HOME: '/',
  CREATE_MEETING: '/create',
  JOIN_MEETING: '/join',
  MEETING: '/meeting/:id',
} as const;

export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  MEETING_NOT_FOUND: 'Meeting not found.',
  MEETING_FULL: 'This meeting is full.',
  INVALID_NAME: 'Please enter a valid name.',
  PERMISSION_DENIED: 'Permission denied.',
  SCREEN_SHARE_LIMIT: 'Maximum screen shares reached.',
  UNKNOWN_ERROR: 'An unexpected error occurred.',
} as const;

// In backend/src/utils/constants.ts (or create it):
export const TIER_LIMITS = {
  free: {
    maxDuration: 1,
    maxScreenShares: 2,
    maxParticipants: 10,
  },
  pro: {
    maxDuration: -1,
    maxScreenShares: 4,
    maxParticipants: 50,
  },
  enterprise: {
    maxDuration: -1,
    maxScreenShares: 8,
    maxParticipants: 100,
  },
};